import React from "react";
import { Navigate } from "react-router-dom";



export default function PRIVATE({ children }) {

    if (sessionStorage.getItem('authenticated') !== 'true') {
        return <Navigate to={`/`} />;
    }

    return children;
}